import { render } from "./BaseConfirmFullscreenModal.vue?vue&type=template&id=688173f2"
import script from "./BaseConfirmFullscreenModal.vue?vue&type=script&lang=js"
export * from "./BaseConfirmFullscreenModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__